/**
 * Phone number formatting utilities
 */

/**
 * Formats a phone number to E.164 format
 * @param phone - Raw phone number string
 * @returns E.164 formatted phone number (e.g., +15551234567)
 */
export const formatPhoneToE164 = (phone: string): string => {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `+1${digits}`;
  } else if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }
  return phone;
};

/**
 * Formats a raw phone number to E.164 format (defaults to +1 for US)
 * @param raw - Raw phone number string
 * @returns E.164 formatted phone number
 */
export const formatPhoneNumberE164 = (raw: string): string => {
  const digits = (raw || '').replace(/\D/g, '');
  return digits ? `+1${digits}` : '+1';
};

/**
 * Formats a phone number for display (e.g., (555) 123-4567)
 * @param phone - Phone number in any format
 * @returns Formatted phone number for display
 */
export const formatPhoneDisplay = (phone: string): string => {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return phone;
};

